// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"MuiDialog-primaryButton-aJbaSp","title":"MuiDialog-title-1uvAPL","crossIcon":"MuiDialog-crossIcon-1WRp1p"};